import { v4 as uuidv4 } from 'uuid';

export function NewsletterCheckboxConfirmation(props = {}) {
	return {
		componentName: 'NewsletterCheckboxConfirmation',
		componentId: uuidv4(),
		props: Object.assign(
			{
				checkboxLabel: '',
				blockClass: 'check-douglas',
			},
			props,
		),
		childrenComponents: [],
	};
}
